export default __webpack_public_path__ + "static/media/kyc-support.e6386fcf.svg";